export const OPD_LANG = {
    langList: ["en", "id", "hn", "cn", "ms", "th"],
    langCode: 'lan'
}